<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [
        { 
            id: '1', 
            stars: '5', 
            title: 'Miranda Ijtsma', 
            content: 'Renault Megane', 
            review: `Heel erg blij met onze nieuwe auto gekocht bij zwagers automotive..
            Heel vriendelijk, goeie service.. reageren snel op vragen.. netjes op orde allemaal.
            En wij zijn super blij 🚘
            Dus mensen zoek je een auto ik raad je zwagers automotive aan.
            
            Groetjes miranda & manuel`
        },
        { 
            id: '2', 
            stars: '5', 
            title: 'Martijn Appel', 
            content: 'Mercedes', 
            review: `Ik heb me mercedes verkocht aan zwagers , aardige mensen heel vriendelijke alles liep prima maar kwam er achter dat de koppeling moest vervangen worden prijs over een gekomen en goede deal gesloten! 
            Goed bedrijf en netjes ! 
            Dank je wel jongens!`
        },
        { 
            id: '3', 
            stars: '5', 
            title: 'Leon van Beelen', 
            content: 'Nieuwe auto', 
            review: `Mijn auto kwam niet door de APK, na snel en vriendelijk contact met Zwagers Automotive een nieuwe auto bij ze gekocht en de oude in kunnen ruilen voor een eerlijke prijs. Alle zaken werden in korte tijd en nauwkeurig afgehandeld. Je wordt goed en persoonlijk geholpen en de service is echt van hoog niveau.
            Je kunt ook naderhand met elke vraag gemakkelijk contact opnemen en je wordt binnen no-time geholpen! Ik blijf hier zeker klant!`
        },
        {
            id: '4',
            stars: '5',
            title: 'Minke M',
            content: 'Peugeot 208',
            review: `Vandaag een Peugeot 208 gekocht bij Zwagers Automotive. Super aardige verkoper en konden de auto ook nog direct meenemen! 3 maand garantie bij de auto en de service was super. Hij heeft nog niet zoveel reviews omdat het bedrijf net is gesplitst, hier twijfelde wij eerst nog om maar blij dat we dat niet hebben gedaan! Super blij met mijn nieuwe auto 🚀😍`
        },
        {
            id: '5',
            stars: '5',
            title: 'Samira Ballich',
            content: 'Auto voor mijn moeder',
            review: `Wij zijn blij met de aanschaf van een auto voor mijn moeder.
            Zwagers automotive zijn erg vriendelijk en professioneel. Wij hadden een goed gevoel zowel bij de auto als bij het bedrijf.
            Wij zullen hier in de toekomst zeker terugkomen mochten wij weer een auto willen aanschaffen!`
        },
        {
            id: '6',
            stars: '5',
            title: 'Dave 074',
            content: 'Peugeot 3008',
            review: `Ik was al een langere tijd opzoek naar een nieuwe auto en toen vond ik een advertentie van een mooie Peugeot 3008.

            Ik had gelijk een bericht gedaan en ik kreeg al snel een reactie, daarna gelijk een afspraak ingepland met een proefrit. Ik was gelijk verkocht en het contact was zeer prettig en correct.

            5 sterren is misschien nog te weinig voor de service, en ook nog voor een mooie prijs een auto gekocht.`
        }
    ]
  }
});

const currentIndex = ref(0);
const currentDot = ref(0);
const interval = ref(null);
const autoplayDelay = 2500; // Define autoplay delay in milliseconds
const itemWidth = ref(0);
const firstItemRef = ref(null);
const transitionEnabled = ref(true);
const itemsToDisplay = ref(1); // Change to reactive reference

const items = computed(() => {
    return [...props.items];
});

const nextSlide = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 768) {
    itemsToDisplay.value = 1;
  } else {
    itemsToDisplay.value = 2;
  }

  currentIndex.value++;
  if (currentIndex.value >= props.items.length - itemsToDisplay.value + 1) {
    currentIndex.value = 0;
  }
  currentDot.value = currentIndex.value % props.items.length;
};

const prevSlide = () => {
  currentIndex.value--;

  if (currentIndex.value < 0) {
    currentIndex.value = props.items.length - 1;
  }

  currentDot.value = (currentIndex.value + props.items.length) % props.items.length;
};

const nextSlidePause = () => {
  nextSlide();
  resetAutoplay();
  debugSliderValues();
};

const prevSlidePause = () => {
  prevSlide();
  resetAutoplay();
  debugSliderValues();
};

const goToSlide = (index) => {
  currentIndex.value = index;
  currentDot.value = index;
  
  resetAutoplay();
  debugSliderValues();
};

const startAutoplay = () => {
    clearInterval(interval.value);
  interval.value = setInterval(nextSlide, autoplayDelay);
};

const stopAutoplay = () => {
  clearInterval(interval.value);
};

const resetAutoplay = () => {
  stopAutoplay();
  setTimeout(startAutoplay, autoplayDelay);
};

onMounted(() => {
  calculateItemWidth();
  window.addEventListener('resize', calculateItemWidth);

  if (props.items.length > 1) {
    interval.value = setInterval(nextSlide, 2500);
  }
  debugSliderValues();
});

onUnmounted(() => {
  clearInterval(interval.value);
  window.removeEventListener('resize', calculateItemWidth);
  debugSliderValues();
});

const calculateItemWidth = () => {
    const firstItem = firstItemRef.value[0];
    if (firstItem) {
        itemWidth.value = firstItem.offsetWidth; // Use offsetWidth for accurate width
    }
};

const itemClasses = computed(() => {
  return {
    'w-full': true,
    'md:w-1/2': props.items.length > 1,
  };
});

const debugSliderValues = () => {
    // console.log('currentIndex:', currentIndex.value);
    
    // console.log('currentDot:', currentDot.value);
    // console.log('props.items.length:', props.items.length);
    // console.log('interval:', interval.value);
    // console.log('autoplayDelay:', autoplayDelay);
    // console.log('itemWidth:', itemWidth.value);
    // console.log('transitionEnabled:', transitionEnabled.value);
    // console.log('itemsToDisplay:', itemsToDisplay.value);
};

const isNextDisabled = computed(() => {

    const screenWidth = window.innerWidth;

    if (screenWidth < 768) {
        itemsToDisplay.value = 1;
    } else {
        itemsToDisplay.value = 2;
    }

    return currentIndex.value >= props.items.length - (itemsToDisplay.value);
});

const isPrevDisabled = computed(() => {
  return currentIndex.value === 0;
});

</script>

<template>
    <div class="w-screen overflow-x-hidden flex flex-col gap-8 justify-center">
        <div class="w-full justify-center" :style="{ transform: `translateX(-${currentIndex * itemWidth}px)` }" :class="{ 'transition-transform duration-500 ease-linear': transitionEnabled }">
            <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl mx-auto flex justify-between">
                <div v-for="(item, index) in items" :key="index" class="flex-shrink-0 pr-4" ref="firstItemRef" :class="itemClasses">
                    <div class="flex flex-col gap-8 rounded-xl bg-gray-100 p-2 sm:p-3 md:p-4">
                        <div class="review-slider-style">
                            <div class="flex justify-start gap-1">
                                <svg v-for="i in 5" :key="i" width="20" height="19" viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg">
                                    <path id="Vector" d="M9.07088 0.612343C9.41462 -0.204115 10.5854 -0.204114 10.9291 0.612346L12.9579 5.43123C13.1029 5.77543 13.4306 6.01061 13.8067 6.0404L19.0727 6.45748C19.9649 6.52814 20.3267 7.62813 19.6469 8.2034L15.6348 11.5987C15.3482 11.8412 15.223 12.2218 15.3106 12.5843L16.5363 17.661C16.744 18.5211 15.7969 19.201 15.033 18.7401L10.5245 16.0196C10.2025 15.8252 9.7975 15.8252 9.47548 16.0196L4.96699 18.7401C4.20311 19.201 3.25596 18.5211 3.46363 17.661L4.68942 12.5843C4.77698 12.2218 4.65182 11.8412 4.36526 11.5987L0.353062 8.2034C-0.326718 7.62813 0.0350679 6.52814 0.927291 6.45748L6.19336 6.0404C6.5695 6.01061 6.89716 5.77543 7.04207 5.43123L9.07088 0.612343Z"
                                    :fill="i <= item.stars ? '#B88F65' : '#776258'" />
                                </svg>
                            </div>
                            <div class="h-40 mt-4">
                                <p class="text-base md:text-lg overflow-hidden text-ellipsis line-clamp-[7] md:line-clamp-6">{{ item.review }}</p>
                            </div>
                            <div class="mt-8 flex flex-col justify-center">
                                <p class="font-bold">{{ item.title }}</p>
                                <p class="text-xs h-3.5">{{ item.content }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-11/12 px:0 md:px-6 xl:px-0 max-w-6xl mx-auto flex justify-between items-center">
            <button @click="prevSlidePause" :disabled="isPrevDisabled" :class="{'border-2 min-h-10 min-w-10 hidden md:flex items-center justify-center rounded-full transition-colors duration-300': true, 'border-black bg-black/40': !isPrevDisabled, 'border-black/40 bg-black/20': isPrevDisabled}">
                <font-awesome-icon :icon="['far', 'chevron-left']" :class="{'text-black': !isPrevDisabled, 'text-black/40': isPrevDisabled}" />
            </button>
            <div class="flex mx-auto gap-2" v-if="props.items.length > 1">
                <button v-for="(item, index) in props.items" :key="index" @click="goToSlide(index)" :class="[ 'h-2.5 w-2.5 rounded-full transition-all duration-500', currentDot === index ? 'bg-black w-8' : 'bg-black/40', (index === props.items.length - 1) ? 'md:hidden' : '' ]"></button>
            </div>
            <button @click="nextSlidePause" :disabled="isNextDisabled" :class="{'border-2 min-h-10 min-w-10 hidden md:flex items-center justify-center rounded-full transition-colors duration-300': true, 'border-black bg-black/40': !isNextDisabled, 'border-black/40 bg-black/20': isNextDisabled}">
                <font-awesome-icon :icon="['far', 'chevron-right']" :class="{'text-black': !isNextDisabled, 'text-black/40': isNextDisabled}" />
            </button>
        </div>
    </div>
</template>